import { render } from "./WalletDetails.vue?vue&type=template&id=7599379e&scoped=true"
import script from "./WalletDetails.vue?vue&type=script&lang=js"
export * from "./WalletDetails.vue?vue&type=script&lang=js"

import "./WalletDetails.vue?vue&type=style&index=0&id=7599379e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7599379e"]])

export default __exports__